import cx from 'classnames';
import { Cancel as CancelIcon } from 'education-icons';
import React from 'react';

import { Image } from '../image/image';
import Modal from '../modal/modal';
import type { ModalProps } from '../modal/types';

import { StudentModalContent } from './__content/student-modal__content';
import { StudentModalFooter } from './__footer/student-modal__footer';
import { b } from './cn';

import './student-modal.scss';

interface Props extends ModalProps {
    background?: string;
    backgroundColor?: string;
    image?: string;
    steeperRadius?: boolean;
}

/**
 * ### StudentModal – респонсив модалка, сохраняющая визуальный стиль ученика
 *
 * Картинки передаются через пропсы.
 * Компоненты:
 * - StudentModal.Content – для заголовков и описания (на 600-800px занимает 50%)
 * - StudentModal.Footer – для кнопок, формочек и др (всегда 100% и ниже контента и картинки)
 *
 * EDUCATION-26860
 */
export const StudentModal = (props: Props) => {
    const {
        children,
        mix,
        hasClose = true,
        background,
        backgroundColor,
        onRequestClose,
        image,
        steeperRadius,
        ...modalProps
    } = props;

    const withImage = Boolean(background || image);
    const withClose = Boolean(hasClose && withImage);

    return (
        <Modal
            hasClose={false}
            mix={cx(b(), mix)}
            onRequestClose={onRequestClose}
            theme={Modal.THEMES.STUDENT_ADAPTIVE}
            {...modalProps}
        >
            <div
                className={b('grid', { 'with-image': withImage, 'steep-radius': steeperRadius })}
                style={{ backgroundColor }}
            >
                {withClose && (
                    <span className={b('close-button-click-area')} onClick={onRequestClose}>
                        <CancelIcon className={b('close-button')} />
                    </span>
                )}
                {withImage && (
                    <div className={b('image')}>
                        {background && <Image className={b('image_background')} src={background} />}
                        {image && <Image className={b('image_main', { 'with-bg': !!background })} src={image} />}
                    </div>
                )}
                {children}
            </div>
        </Modal>
    );
};

StudentModal.Content = StudentModalContent;
StudentModal.Footer = StudentModalFooter;
